import React, { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useInView } from 'react-intersection-observer';
import { Grid } from 'src/ui/common/atoms/grid';
import { LandingSection } from 'src/ui/common/layouts/landing-section';
import {
    useCollectionsListEntities,
    useFetchCollectionsList,
} from 'src/features/common/collection/hooks/use-collections-list';
import { TopCollectionCard } from '../../components/top-collection-card';
import { TopCollectionCardPreloader } from '../../components/top-collection-card-preloader';
import { useTopCollections } from '../../hooks/use-top-collections';

const CARDS_COUNT = 8;
export const TopCollectionsContainer = () => {
    const { t } = useTranslation(['pages']);
    const { fetch, clear, topCollections, isLoading } = useTopCollections();
    const collectionEntities = useCollectionsListEntities();
    const fetchCollectionEntities = useFetchCollectionsList();
    const { ref, inView } = useInView({
        triggerOnce: true
    });

    const locale: { title: string } = useMemo(() => ({
        ...t('home.widgets.topCollections', { ns: 'pages', returnObjects: true }),
    }), [t]);

    useEffect(() => {
        inView && fetch({ count: CARDS_COUNT });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [inView]);

    useEffect(() => clear
        // eslint-disable-next-line react-hooks/exhaustive-deps
    , []);

    useEffect(() => {
        if (topCollections.length) {
            fetchCollectionEntities({
                ids: topCollections.map(({ id }) => id)
            });
        }
    }, [fetchCollectionEntities, topCollections]);

    return (
        <div ref={ref}>
            <LandingSection title={locale.title}>
                <Grid rowGap={12} columnGap={12} sm={3} md={4}>
                    {isLoading && (
                        [...Array(CARDS_COUNT).keys()].map((el) => (
                            <TopCollectionCardPreloader key={el} rankingPosition={el + 1} />
                        ))
                    )}
                    {topCollections.map((topCollection, index) => (
                        collectionEntities[topCollection.id] ? (
                            <TopCollectionCard
                                collection={collectionEntities[topCollection.id]!}
                                copies={topCollection.copies}
                                key={topCollection?.id!}
                                rankingPosition={index + 1}
                            />
                        ) : null
                    ))}
                </Grid>
            </LandingSection>
        </div>
    );
};
